import axios from "axios";

export function apiGetUsages(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/usages" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetUsage(instance, id, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/usages/" +
        id +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveUsage(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/usages", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateUsage(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/usages/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteUsage(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/usages/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
